import React, { useLayoutEffect } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { clearStudioFilterStorageByInstance } from '../utils/studioFilterStorage';
import { STUDIO_INFLUENCER_FILTER_INSTANCE_ID } from '../components/InfluencerWrapper/types';

const Influencer = () => {
  const { gameCode, studioId } = useParams<{ gameCode?: string; studioId?: string; }>() || {};

  // 路由级生命周期：进入/离开 Influencer 页时清理 Studio 专用筛选缓存
  // Tab 切换不触发路由 unmount，因此 Tab 间仍可通过 sessionStorage 继承
  useLayoutEffect(() => {
    clearStudioFilterStorageByInstance(STUDIO_INFLUENCER_FILTER_INSTANCE_ID);
    return () => {
      clearStudioFilterStorageByInstance(STUDIO_INFLUENCER_FILTER_INSTANCE_ID);
    };
  }, []);

  return (
    <CommonPageRender
      key={`${gameCode}-${studioId}`}
      reqParams="/influencer"
      frameType="game"
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default Influencer;
